import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { ApplicationContext } from "../../context/application_ctx";
import { IconButtonMA, TextFieldMA } from "../../styles/styledComponents";
import { Close, Done } from "@mui/icons-material";
import { HttpStatusCode } from "axios";
import { updateEmployee } from "../../api/controllers/registeredUserController";
import { theme } from "../../styles/theme";
import _ from "lodash";
export default function UpdateEmployeeDialog({ setOnBoardSnack, setError }) {
  // context
  const {
    isOpenEditEmployeeDialog,
    setIsOpenEditEmployeeDialog,
    filteredList,
    registerDetails,
  } = useContext(ApplicationContext);

  const [epId, setEpId] = useState("");
  const [epName, setEpName] = useState({});
  const [epEmail, setEpEmail] = useState("");
  const [epDesignation, setEpDesignation] = useState("");
  const [epDepartment, setEpDepartment] = useState("");
  const [licenseStatus] = useState("unallocated");
  // const [loaderState, setLoaderState] = useState(false);
  let tableData = {
    employeeId: registerDetails?.employeeId,
    name: registerDetails?.name,
    lastName: registerDetails?.lastName,
    designation: registerDetails?.designation,
    department: registerDetails?.department,
  };

  let stateValues = {
    employeeId: epId?.trim(),
    name: epName?.firstName?.trim(),
    lastName: epName?.lastName?.trim(),
    designation: epDesignation?.trim(),
    department: epDepartment?.trim(),
  };
  function handleCloseRegisterDialog() {
    setIsOpenEditEmployeeDialog(false);
  }
  // async function handleUpdateDetail() {

  //     let tempArr = [...addRowEmp];

  //     tempArr.push({
  //         "epName": epName,
  //         "epEmail": epEmail,
  //         "epDesignation": epDesignation,
  //         "licenceStatus": licenseStatus
  //     })
  //     setAddRowEmp([...tempArr]);

  //     handleCloseRegisterDialog();

  //     return;

  //     // try {

  //     //     let body = {
  //     //         "epName": epName,
  //     //         "epEmail": epEmail,
  //     //         "epDesignation": epDesignation,
  //     //         "licenceStatus": licenseStatus
  //     //     }

  //     //     if (!category) {
  //     //         delete body[category]
  //     //     }

  //     //     if (!subCategory) {
  //     //         delete body[subCategory]
  //     //     }

  //     //     setLoading(true);

  //     //     let response = await createEventController(body);

  //     //     setLoading(false);
  //     //     console.log(response, "response");

  //     //     if (response.status === HttpStatusCode.Ok) {

  //     //         // setCategory("");
  //     //         // setDescription("");

  //     //         // update the category list
  //     //         // let tempArray = [...sub_IncidentDataList];
  //     //         // tempArray.push(response.data.data.saveIncidentData)

  //     //         // setincidentDataList(prev => [...prev, response.data.data.saveIncidentData]);

  //     //         // setSub_IncidentDataList(tempArray)

  //     //         // close dialog box
  //     //         // handleCloseCreateDialog();

  //     //     } else {
  //     //         // if any error message show the message to user
  //     //         if (typeof (response?.data?.message) === 'string' || (response?.data?.message) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data?.message, SnackbarStatusType.warning);
  //     //         } else if (typeof (response?.data?.error) === 'string' || (response?.data?.error) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data?.error, SnackbarStatusType.warning);
  //     //         } else if (typeof (response.data) === 'string' || (response.data) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data, SnackbarStatusType.warning);
  //     //         }
  //     //     }
  //     // } catch (err) {
  //     //     console.log("Error in Create Event : ", err);
  //     // }

  // }

  const handleUpdateEmployeeDetail = async () => {
   
 
    try {
      // setLoaderState(true);

      let response = await updateEmployee(
        {
          employeeId: epId?.trim(),
          name: epName?.firstName?.trim(),
          lastName: epName?.lastName?.trim(),
          designation: epDesignation?.trim(),
          department: epDepartment?.trim(),
        },
        registerDetails?._id
      );

      // setLoaderState(false);
      console.log(response, "response add");
      if (response.status === HttpStatusCode.Ok) {
        setError(response.data.message);
        setOnBoardSnack(true);

        let tempArray = [...filteredList];

        let foundIndex = filteredList.findIndex(
          (x) => x._id === registerDetails?._id
        );
        tempArray[foundIndex].name = response?.data?.updateData?.name;
        tempArray[foundIndex].lastName = response?.data?.updateData?.lastName;
        tempArray[foundIndex].designation =
          response?.data?.updateData?.designation;
        tempArray[foundIndex].department =
          response?.data?.updateData?.department;
        tempArray[foundIndex].employeeId =
          response?.data?.updateData?.employeeId;

        // setEmployeesList(tempArray);
        // setFilteredList(tempArray);

        handleCloseRegisterDialog();
        // let tempArray = [...employeesList]

        // tempArray.push(response.data.employee);

        // setEmployeesList(tempArray);

        // setReloadEmployees(true);
        // setTimeout(() => {
        //   setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setEpId(registerDetails?.employeeId);
    setEpName({
      firstName: registerDetails.name,
      lastName: registerDetails.lastName,
    });
    setEpEmail(registerDetails.email);
    setEpDesignation(registerDetails.designation);
    setEpDepartment(registerDetails.department);
    // setLicenseStatus(registerDetails.licenseStatus);
  }, [registerDetails]);

  console.log(registerDetails, "registerDetails");

  return (
    <Dialog
      onClose={handleCloseRegisterDialog}
      open={isOpenEditEmployeeDialog}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "50%",
          //  minHeight: "60vh"
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" color={theme.col_3}>
            Update Employee
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <IconButtonMA
              disabled={
                _.isEqual(tableData , stateValues)
                  ? true
                  : Object.values(epName).some((data) => data === "")
                  ? true
                  : licenseStatus === ""
                  ? true
                  : !epId ? true : false
              }
              size="small"
              onClick={handleUpdateEmployeeDetail}
            >
              <Done />
            </IconButtonMA>
            <IconButtonMA size="small" onClick={handleCloseRegisterDialog}>
              <Close />
            </IconButtonMA>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 1.5 }}>
        <Box py={0.8} px={1} display="flex" flexDirection="column" gap={2}>
          <Box px={1} py={1} display="flex" alignItems="center" gap={2 + 1}>
            <TextFieldMA
              value={epName.firstName}
              required
              // error={
              //     email === null
              //         ? false
              //         : !validator.isEmail(email) && email !== ""
              //             ? true
              //             : email === ""
              //                 ? true
              //                 : false
              // }
              // helperText={
              //     email === null
              //         ? ""
              //         : !validator.isEmail(email) && email !== ""
              //             ? "Enter valid email"
              //             : email === ""
              //                 ? "Email is required"
              //                 : ""
              // }
              onChange={(e) =>
                setEpName({ ...epName, firstName: e.target.value })
              }
              fullWidth
              label="Employee Name"
              inputProps={{ maxLength: 64 }}

            />
            <TextFieldMA
              value={epName?.lastName}
              required
              // error={
              //     email === null
              //         ? false
              //         : !validator.isEmail(email) && email !== ""
              //             ? true
              //             : email === ""
              //                 ? true
              //                 : false
              // }
              // helperText={
              //     email === null
              //         ? ""
              //         : !validator.isEmail(email) && email !== ""
              //             ? "Enter valid email"
              //             : email === ""
              //                 ? "Email is required"
              //                 : ""
              // }
              onChange={(e) =>
                setEpName({ ...epName, lastName: e.target.value })
              }
              fullWidth
              label="Last Name"
              inputProps={{ maxLength: 64 }}

            />
          </Box>

          <Box px={1} py={1} display="flex" alignItems="center" gap={2 + 1}>
            <TextFieldMA
              required
              value={epId}
              onChange={(e) => setEpId(e.target.value)}
              fullWidth
              label="Employee Id"
              inputProps={{ maxLength: 64 }}

            />
            <TextFieldMA
              disabled
              required
              value={epEmail}
              onChange={(e) => setEpEmail(e.target.value)}
              fullWidth
              label="Employee Email"
              inputProps={{ maxLength: 64 }}

            />
          </Box>
          <Box px={1} py={1} display="flex" alignItems="center" gap={2 + 1}>
            <TextFieldMA
              value={epDesignation}
              onChange={(e) => setEpDesignation(e.target.value)}
              fullWidth
              inputProps={{ maxLength: 20 }}
              label="Employee Designation"
            />
            <TextFieldMA
              value={epDepartment}
              onChange={(e) => setEpDepartment(e.target.value)}
              fullWidth
              label="Employee Department"
              inputProps={{ maxLength: 20 }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
